import { TipoOrigemDespesaGroupPay } from "constants/EnumTipoOrigemDespesaGroupPay";
import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import { downloadFile } from "shared/util/functions/download/DownloadFunctions";

import { Cond21CloudResponse } from "types/response/Cond21CloudResponse";
import { DespesaGroupPayDetalhada } from "types/response/groupPay/DespesaGroupPayDetalhadaResponse";

type params = {
  uuidDespesaNoGroupPay?: string;
  origemDespesa?: TipoOrigemDespesaGroupPay;
  fileName?: string;
};

export const useGetDownloadDocumentoDespesaGroupPay = (params: params) => {
  const onSuccess = (response: Cond21CloudResponse<string>) => {
    downloadFile(response.payload, params.fileName || "Documento despesa.pdf");
  };

  const onError = () => {
    toast.error("Erro ao baixar documento da despesa do Group Pay");
  };

  return useFetch<DespesaGroupPayDetalhada>({
    key: ["download-documento-despesa-group-pay", params],
    url: api.groupPay.getDownloadDocumentoDespesa,
    enabled: false,
    params: params,
    onSuccess,
    onError,
  });
};
